import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import IDBadge from "./IDBadge";
import Toolstack from "./Toolstack";
function About() {
  return (
    <Container fluid className="about-section bg-accent-black text-white min-h-[90vh] py-24 pt-32">
      <Particle />
      <Container>
        {/* Integrated Home2 Content */}
        <Row className="items-center mb-32">
          <Col md={8} className="text-left">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 uppercase tracking-tight text-white">
              A Little <span className="text-zinc-500">About Me</span>
            </h2>
            <div className="space-y-6 text-zinc-400 text-lg leading-relaxed">
              <p>
                I am a Direct Response Video Editor and Visual Asset Specialist with a<span className="text-white font-semibold"> passion for turning cold traffic into loyal customers.</span>
              </p>
              <p>
                In the fast-paced world of performance marketing,
              </p>
              <p>
                <span className="text-white font-semibold"> I know that you only have three seconds to stop the scroll—and my mission is to make those seconds count.</span>
              </p>

            </div>
          </Col>
          <Col md={4} className="flex justify-center mt-12 md:mt-0 relative">
            <IDBadge />
          </Col>
        </Row>
        <h1 className="project-heading text-3xl font-bold mt-20 mb-12 text-center uppercase tracking-widest text-zinc-500">
          <strong className="text-white">Tools</strong> I use
        </h1>
        <Toolstack />
      </Container>
    </Container>
  );
}

export default About;
